import { css } from 'lit';

export const style = css`
  .carousel-container {
    align-items: center;
    display: flex;
    flex-direction: column;
    overflow: clip;
    width: 100%;

    @media only screen and (min-width: 1024px) {
      margin-bottom: 16px;
      overflow: unset;
    }

    .carousel-content-container {
      display: flex;
      overflow-x: hidden;
      scroll-behavior: smooth;
      scroll-snap-type: x mandatory;
      width: 100%;

      @media only screen and (min-width: 1024px) {
        justify-content: center;
        overflow-x: unset;
        width: 200%;
      }
    }

    .tab-indicator {
      display: flex;
      margin-bottom: 24px;

      @media only screen and (min-width: 1024px) {
        display: none;
      }
    }
  }
`;
